// =============================================================================
// FILE PATH: src/modules/pms/pages/UserBPMappingPage.js
// =============================================================================

import React, { useState, useEffect } from "react";
import UserBPMappingForm from "../components/UserBPMappingForm";
import { getUserBPMappingList } from "../services/userBpMappingService";
import { deleteUserBPMapping } from "../services/userBpMappingService";


export default function UserBPMappingPage() {

  const [data, setData] = useState([]);
  const [openForm, setOpenForm] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    getUserBPMappingList()
      .then(res => {
        setData(res.data.data || []);
      })
      .catch(err => console.error(err));
  };
  const handleDelete = (employeeId) => {

  if (!window.confirm("Are you sure you want to delete this mapping?")) {
    return;
  }

  deleteUserBPMapping(employeeId)
    .then(() => {
      alert("Mapping deleted successfully");
      loadData(); // refresh table
    })
    .catch(err => {
      console.error(err);
      alert("Error deleting mapping");
    });
};

  return (
    <div style={styles.container}>

      {/* HEADER */}
      <div style={styles.header}>
        <h2 style={styles.title}>User ↔ Business Partner Mapping</h2>

        <button
          style={styles.addBtn}
          onClick={() => setOpenForm(true)}
        >
          + Map Employee to BP
        </button>
      </div>

      {/* TABLE */}
      <div style={styles.tableContainer}>

        <div style={styles.headerRow}>
          <div style={styles.col}>Employee</div>
          <div style={styles.col}>Business Partner</div>
          <div style={styles.col}>Actions</div>
        </div>

        {/* 🔥 SHOW DATA */}
        {data.length > 0 && data.map((row, index) => (
          <div key={index} style={styles.row}>
            <div style={styles.col}>{row.employee_name}</div>
            <div style={styles.col}>
            {row.bp_name} ({row.bp_role})
            </div>

            <div style={styles.col}>
            <button
              style={styles.deleteBtn}
              onClick={() => handleDelete(row.employee_id)}
            >
              Delete
            </button>
          </div>
          </div>
        ))}

        {data.length === 0 && (
          <div style={styles.empty}>
            No mappings found
          </div>
        )}

      </div>

      {/* 🔥 FORM WITH REFRESH */}
      <UserBPMappingForm
        open={openForm}
        onClose={() => {
          setOpenForm(false);
          loadData(); // 🔥 reload after save
        }}
      />

    </div>
  );
}

const styles = {

  container: {
    padding: 20
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15
  },

  title: {
    margin: 0
  },

  addBtn: {
    padding: "8px 14px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    cursor: "pointer"
  },

  tableContainer: {
    border: "1px solid #ddd",
    borderRadius: 6,
    overflow: "hidden",
    background: "#fff"
  },

  headerRow: {
    display: "flex",
    background: "#f3f4f6",
    padding: "10px",
    fontWeight: 600
  },
  deleteBtn: {
  padding: "4px 8px",
  background: "#dc2626",
  color: "#fff",
  border: "none",
  borderRadius: 4,
  cursor: "pointer"
},

  row: { // 🔥 ADDED
    display: "flex",
    padding: "10px",
    borderTop: "1px solid #eee"
  },

  col: {
    flex: 1,
    textAlign: "center"
  },

  empty: {
    padding: 20,
    textAlign: "center",
    color: "#6b7280"
  }

};